export function formatRupiah(value, withPrefix = true) {
    if (typeof value !== 'number') {
        value = parseInt(value);
    }

    if (isNaN(value)) return withPrefix ? 'Rp 0' : '0';

    const formatted = value.toLocaleString('id-ID', {
        minimumFractionDigits: 0,
    });

    return withPrefix ? `Rp ${formatted}` : formatted;
}

export function parseRupiah(value) {
    if (!value) return 0
    const num = parseInt(String(value).replace(/\D/g, ''), 10)
    return isNaN(num) ? 0 : num
}